// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1bgwo","messages":"Chat_messages__2CF2Z","dateDivider":"Chat_dateDivider__1R9ip"};